import { Stack } from '@mui/system';
import { Checkbox, Typography, useTheme } from '@mui/material';
import React from 'react';
//constants
import { useAppSelector } from 'hooks/redux.hooks';
import { getCurrencies } from 'state/reducers/global.reducer';
import { CustomCheckbox } from 'theme/elements/Inputs';
import { getMobile } from 'state/reducers/ui.reducers';
import FormInsideCard from 'components/FormElementsComponent/FormInsideCard';

interface BankAccountsProps {
	account: any;
	handleBankPick: any;
	isSelected: boolean;
	disabled: boolean;
}

export default function BankAccountDetails(props: BankAccountsProps) {
	const { account, isSelected, handleBankPick, disabled } = props;
	const currencies = useAppSelector(getCurrencies);
	const currency = currencies.find((currency: any) => currency.code === 'ILS');
	const theme = useTheme();
	const isMobile = useAppSelector(getMobile);
	const handleBankChoose = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleBankPick(Number(event.target.value));
	};

	return (
		<FormInsideCard
			sx={{
				margin: 0,
			}}
			key={`bank-account-${account?.accountNumber}`}
		>
			<Stack direction="row" spacing={3}>
				<CustomCheckbox
					sx={{
						'& .Mui-checked svg': {
							'& path': {
								fill: disabled && isSelected ? theme.palette.root.darkGrayed : 'auto',
							},
						},
					}}
				>
					<Checkbox
						sx={{
							color: '#2C3E50',
							'&.Mui-checked': {
								color: '#ffffff',
							},
							height: 'max-content',
						}}
						checked={isSelected}
						value={account?.id}
						onChange={handleBankChoose}
						disabled={disabled}
					/>
				</CustomCheckbox>
				<Stack direction="column" width={'100%'}>
					<Stack direction="row" justifyContent={'space-between'}>
						<Typography variant="caption">{account?.accountOwnerName}</Typography>
						<Typography variant="captionRegular">{currency.name}</Typography>
					</Stack>
					<Stack direction="row" justifyContent={'space-between'}>
						<Typography variant={isMobile ? 'caption' : 'subtitle2'}>
							{account?.bankName.toString().trim()}
						</Typography>
						<Typography variant={isMobile ? 'caption' : 'subtitle2'}>{account?.bankBranch}</Typography>
						<Typography variant={isMobile ? 'caption' : 'subtitle2'}>{account?.accountNumber}</Typography>
					</Stack>
				</Stack>
			</Stack>
		</FormInsideCard>
	);
}
